import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import moment from "moment";
import Select from "react-select";
import APIVariables from "@/services/api-variables";
import Axios from "@/services/Axios";
import { handleCatch } from "@/shared/helpers";
import { pafSectionLabelClass } from "../constants/viewPafConstants";
import { hasDispensingBrandAssigned } from "../utils/viewPafFormLogic";
import { ViewPafDropdownIndicator } from "./ViewPafDropdownIndicator";

function PafEditBrandDateFields({ form, setForm, productId }) {
  const [mahOptions, setMahOptions] = useState([]);
  const showBrandAndDateFields = hasDispensingBrandAssigned(form);

  useEffect(() => {
    if (!productId || !showBrandAndDateFields) return;
    Axios.get(`${APIVariables.MAHS}/${productId}`)
      .then((res) => {
        const list = Array.isArray(res.data) ? res.data : res.data?.results ?? [];
        setMahOptions(
          list.map((mah) => ({
            value: mah.id,
            label: mah.name ?? mah.marketing_holder ?? String(mah.id),
          }))
        );
      })
      .catch(handleCatch);
  }, [productId, showBrandAndDateFields]);

  if (!showBrandAndDateFields) {
    return null;
  }

  const selectedMah =
    mahOptions.find(
      (o) =>
        o.value === form?.edit_marketing_holder_id ||
        o.label === form?.marketing_holder
    ) ?? null;

  const dispensingValue =
    form?.edit_dispensing_date ??
    form?.amended_dispensed_date ??
    form?.dispensed_date;

  const dateInputValue = dispensingValue
    ? moment(dispensingValue).format("YYYY-MM-DD")
    : "";

  return (
    <div
      className="mt-4 space-y-4 border-t border-[#dcdcdc] pt-4"
      data-testid="view-paf-edit-brand-date"
    >
      <div className="max-w-xs" data-testid="view-paf-edit-brand">
        <label
          className={pafSectionLabelClass}
          data-testid="view-paf-dispensing-brand-label"
        >
          Dispensing Brand
        </label>
        <div data-testid="view-paf-dispensing-brand-select">
          <Select
            menuShouldScrollIntoView={false}
            classNamePrefix="custom-select"
            className="mt-1"
            components={{
              DropdownIndicator: ViewPafDropdownIndicator,
              IndicatorSeparator: () => null,
            }}
            options={mahOptions}
            value={selectedMah}
            placeholder="Select brand"
            inputId="view-paf-edit-brand-select"
            onChange={(option) => {
              setForm((prev) => ({
                ...prev,
                edit_marketing_holder_id: option?.value ?? null,
              }));
            }}
          />
        </div>
      </div>

      <div className="max-w-xs" data-testid="view-paf-edit-dispensing-date">
        <label
          className={pafSectionLabelClass}
          data-testid="view-paf-nominated-date-of-dispensing-label"
        >
          Nominated Date of Dispensing
        </label>
        <input
          type="date"
          className="mt-1 w-full rounded-md border border-[#dcdcdc] bg-white px-3 py-2 text-sm text-[#3c3c3c]"
          value={dateInputValue}
          data-testid="view-paf-edit-dispensing-date-input"
          min={
            form?.pfa_issued
              ? moment(form.pfa_issued).format("YYYY-MM-DD")
              : undefined
          }
          max={moment().format("YYYY-MM-DD")}
          onChange={(e) => {
            const raw = e.target.value;
            setForm((prev) => ({
              ...prev,
              edit_dispensing_date: raw
                ? moment(raw).startOf("day").toISOString()
                : null,
            }));
          }}
        />
      </div>
    </div>
  );
}

PafEditBrandDateFields.propTypes = {
  form: PropTypes.object,
  setForm: PropTypes.func.isRequired,
  productId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

export default PafEditBrandDateFields;
